import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React, { PropsWithChildren } from "react";

type IProps = PropsWithChildren<{
  visibleWhen?: boolean;
  title: string;
}>;

export const LevelNodesSection: React.FC<IProps> = ({
  visibleWhen,
  children,
  title,
}) => {
  if (visibleWhen === false) {
    return null;
  }

  return (
    <>
      <Spacer height="4x" />
      <Typography variant="paragraphSansRegular">{title}</Typography>
      <Spacer height="1x" />
      {children}
    </>
  );
};
